import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Trans } from '../../components/i18n';
import { forgotPassword } from '../../services/auth';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import Banner from '../../components/ui/Banner';

const AuthForgotPasswordPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [isSent, setIsSent] = useState(false);

	document.title = `${t('general.app_name')} | ${t('general.reset_password')}`;

	const handleSubmit = async () => {
		setIsLoading(true);
		await forgotPassword(email);
		setIsLoading(false);
		setIsSent(true);
	};

	return (
		<div className='flex flex-col flex-1 justify-center items-center scroll-y'>
			<div className='flex flex-col max-w-md w-full'>
				<h3 className='text-3xl font-bold '>
					<Trans i18nKey='login.forgot_password_title' />
				</h3>
				<p className='text-sm text-gray-500 mt-3'>
					<Trans i18nKey='login.forgot_password_description' />
				</p>
				<div className='flex flex-col mt-10'>
					{isSent ? (
						<Banner label={t('login.forgot_password_sent')} variant='success' />
					) : (
						<>
							<Input
								label={t('login.email')}
								type='email'
								icon='ri-mail-open-line'
								placeholder={t('login.email_placeholder', {
									app_name: t('general.app_name').toLowerCase(),
								})}
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								errorText={t('login.email_error')}
								validation={
									/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
								}
							/>
							<Button
								className='mt-4'
								type='solid'
								size='large'
								variant='primary'
								disabled={!email}
								loading={isLoading}
								onClick={handleSubmit}
							>
								<Trans i18nKey='login.send_reset_link' />
							</Button>
						</>
					)}
					<Button
						className='mt-10 text-left w-fit'
						type='text'
						size='medium'
						variant='secondary'
						onClick={() => navigate('/login/email')}
					>
						<i className='ri-arrow-left-line hover:text-decoration-none' />
						<Trans i18nKey='login.go_back_email' />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default AuthForgotPasswordPage;
